<template>
  <span v-for="(contact, index) in contacts" :key="contact.mdi_icon">
    <span v-if="index > 0">|</span>
    <a
      :href="contact.link"
      target="_blank"
      rel="noopener"
      class="contact-icon"
      :aria-label="contact.mdi_icon"
    >
      <v-icon>{{ 'mdi-' + contact.mdi_icon }}</v-icon>
    </a>
  </span>
</template>

<script>
import contactData from 'data/contact.json';
export default {
  name: 'ContactBar',

  data: () => ({
    contacts: contactData,
  }),
};
</script>

<style>
.contact-icon {
  text-decoration: none;
  color: white;
  padding: 0 10px;
  font-size: 1.1em;
}
</style>
